// import { takeLatest, put, call, select } from "redux-saga/effects";

import { select, takeLatest } from '@redux-saga/core/effects';
import { ACTION_TOGGLE } from '../actions/layout';
import { ADD, REMOVE, REMOVE_ARGS } from '../actions/watchlist';
import { IWatchlistItem } from '../helpers/watchlist';
import { LS_LAYOUT_KEY } from '../reducers/layout';
import { LS_WATCHLIST_KEY } from '../reducers/watchlist';

/**
 * Save layout changes to localStorage
 */
function* onSaveLayout(): any {
  const layout: any = yield select(state => state.layout);
  localStorage.setItem(LS_LAYOUT_KEY, JSON.stringify(layout));
}
/**
 * Save watchlist changes to localStorage
 */
function* onSaveWatchlist(): any {
  const watchlist: IWatchlistItem[] = yield select(state => state.watchlist);
  localStorage.setItem(LS_WATCHLIST_KEY, JSON.stringify(watchlist));
}

export default function* accountsSaga() {
  // yield takeLatest(SIGN_OUT, signOutRedirect);
  yield takeLatest(ACTION_TOGGLE, onSaveLayout);
  yield takeLatest(ADD, onSaveWatchlist);
  yield takeLatest(REMOVE, onSaveWatchlist);
  yield takeLatest(REMOVE_ARGS, onSaveWatchlist);
}
